module.exports = __webpack_public_path__ + "img/star.58fbea45.png";